import React, { createContext } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../util/i18n';
import { DEFAULT_LANGUAGE } from '../../util/languages';

export const LanguageContext = createContext({
  language: DEFAULT_LANGUAGE as string,
  setLanguage: (newLanguage: string) => {}, // Placeholder for update function
});

// i18next is the source of truth; this context just exposes it.
export const LanguageProvider = ({ children }: any) => {
  const { i18n: instance } = useTranslation();

  const handleLanguageChange = async (newLanguage: string) => {
    await i18n.changeLanguage(newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language: instance.language, setLanguage: handleLanguageChange }}>{children}</LanguageContext.Provider>
  );
};
